$(document).ready(function() {
  $('.product_media_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: '<button type="button" class="slick-next pull-right"><span><i class="fas fa-long-arrow-right"></i></span></button>',
    prevArrow: '<button type="button" class="slick-prev pull-left"><span><i class="fas fa-long-arrow-left"></i></span></button>',
    infinite: false,
    fade: true,
    asNavFor: '.product_thumb_slider'
  });

  $('.product_thumb_slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product_media_slider',
    dots: false,
    centerMode: false,
    arrows: false,
    focusOnSelect: true
  });
  $('.single-option-selector').on('change', function() {
    $('.product_media_slider .product-single__media-wrapper').removeClass('hide');
  });

  $(".accordion-toggle").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".accordion-content")
      .slideUp(200);
      $(".accordion-toggle")
      .removeClass("fal fa-times")
      .addClass("fal fa-plus");
    } else {
      $(".accordion-toggle")
      .removeClass("fal fa-times")
      .addClass("fal fa-plus");
      $(this)
      .find("i")
      .removeClass("fal fa-plus")
      .addClass("fal fa-times");
      $(".accordion-toggle").removeClass("active");
      $(this).addClass("active");
      //$(".accordion-content").slideUp(200);
      $(this)
      .siblings(".accordion-content")
      .slideDown(200);
    }
  });

  /* Home Press Section Slider - Start */
  $('#pr-carousel').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});
$('.pr-carousel-item:nth-child(2)').addClass('active');
$('.pr-carousel-item .awward-logo-img').click(function() {
  $(this).parent().toggleClass('active');
  $('.pr-carousel-item').not($(this).parent()).removeClass('active');
});
/* Home Press Section Slider - End */

/* Home Customer Testimonial Section Slider - Start*/
$('#home-testimonials-slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  	autoplay: true,
  	autoplaySpeed: 4000,
   	focusOnSelect: true
});
/* Home Customer Testimonial Section Slider - End*/
  
});

//accordion
function killSubscribe() {
  var x = document.getElementById("pop-overlay");
  var y = document.getElementById("pop-subscribe");
  x.style.display = "none";
  y.style.display = "none";
} 
function showMobile() {
  var x = document.getElementById("mobile-navigation");
  if (x.style.display === "flex") {
    x.style.display = "none";
  } else {
    x.style.display = "flex";
  }
} 
function myFunction(y) {
  if (y.matches) { // If media query matches
    var mobileNavigation = document.getElementById('mobile-navigation');
    if (mobileNavigation) {
        mobileNavigation.style.display = 'none';
    }
  }
}

var y = window.matchMedia("(min-width: 992px)")
myFunction(y) // Call listener function at run time
y.addListener(myFunction) // Attach listener function on state changes


//Kill Subscribe Popup Script
function killSubscribe() {
  var x = document.getElementById("pop-overlay");
  var y = document.getElementById("pop-subscribe");
  x.style.display = "none";
  y.style.display = "none";
} 

//Kill Decode Popup Script
function killDecode() {
  var x = document.getElementById("pop-overlay");
  var y = document.getElementById("pop-decode-signin");
  x.style.display = "none";
  y.style.display = "none";
}

$(document).ready(function() {
  if($("#product-slider").length) {
    $("#product-slider").lightSlider({
      gallery: true,							   
      item:1,
      loop:true,
      thumbItem:4,
      thumbMargin:8,
      slideMargin:0,
      enableDrag: false,
      currentPagerPosition:'left',
      onSliderLoad: function(el) {
        el.lightGallery({
          selector: '#imageGallery .lslide'
        });
      }   
    });
  }
  $('#check').change(function () {
    $('.needsclick ').prop("disabled", !this.checked);
  }).change()
});
jQuery(document).ready(function($) {

  if( getCookie('popupCookie') != 'submited'){
    // if(getCookie('popupCookie') != 'closed' ){
    $('#footer-bottom').css("display", "block").hide().fadeIn();
    // }
  }

  $('a.boxed-button-footer').click(function(){
    $('#footer-bottom').fadeOut();
    setCookie( 'popupCookie', 'submited', 15000 );
  });

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  $('#pop-quick-checkout #product-options label.product-option').click(function(){
    var id=$(this).parent().find('.variants_input').val();
    $(".product-form__variants").val(id).trigger("change");
    var price = $(this).attr("data-price");
    $(this).closest("#pop-quick-checkout").find(".product-detail-price").text(price);
    var quant = parseInt($(this).attr("data-inv"));
    console.log(quant);
//     if(quant >= 1){
//       $('#pop-quick-checkout #product-options .shopify-product-form button').attr("aria-label","Add to cart").attr("disabled",false);
//       $('#pop-quick-checkout #product-options .shopify-product-form span[data-add-to-cart-text]').text("Add to cart");
//     }
//     else{
//       $('#pop-quick-checkout #product-options .shopify-product-form button').attr("aria-label","Sold Out").attr("disabled",true);
//       $('#pop-quick-checkout #product-options .shopify-product-form span[data-add-to-cart-text]').text("Sold Out");
//     }
  });
  $(".quickshop").click(function(){
    const config = {
      productId: 6546195251258, // Required
      injectionParent: '#product_form_', // The node that will have the widget injected in
      injectionMethod: 'prepend', // How will the widget be injected 
      injectFn: (node, target) => {}, // Runs a custom injection function 
      selectors: {
        price: ['.subs-product-detail-price'], // the selectors that will be updated based on subscription
        variant: ['.product-form__variants'] // The variants to watch for to update the subscription prices
      }
    };
    window.ReChargeWidget.createWidget(config);
    $("#pop-overlay").css("display","flex");
    $(this).closest(".row-eq-height").find("#pop-quick-checkout").css("display","flex");
  });
  $(".box-close").click(function(){
    $("#pop-overlay").css("display","none");
    $(this).closest(".row-eq-height").find("#pop-quick-checkout").css("display","none");
  });
  //Newsletter Popup Cookie
  function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  function showNewsletterPopUp(){
    $('#pop-subscribe,#pop-overlay').delay(5000).fadeIn(100);
    $('.box-close').click(function(){
      $('#pop-subscribe,#pop-overlay').hide();
      setCookie("modalPopup", 'enable', 24);
    });   
  }
  function checkCookie() {
    var user = getCookie("modalPopup");

    if(typeof user === "undefined" || user == null || user == ''){
      showNewsletterPopUp();

    }
  }
  checkCookie();

  $('input.name_space').keypress(function( e ) {
    if(e.which === 32) 
      return false;
  });
  $("body").on("click","#pop-quick-checkout .star-clickable",function(e){
      e.preventDefault();
      e.stopPropagation();
      window.location.replace("https://eighthdayskin.com/products/the-regenerative-serum/#review_switch");
    });
  /*23-11-2021- Update to header and navigation*/
  if($('#hamburger-menu').length) {
  	$('#hamburger-menu').click(function() {
  		$('body').toggleClass('open-navigation');
  		$(this).toggleClass('active');
  	});
  	$('#hamburger-menu-close').click(function() {
  		$('body').removeClass('open-navigation');
  		$('#hamburger-menu').removeClass('active');
         $('body').toggleClass('close-navigation');
  	});
  }
  if($('.toggle-submenu').length) {
    $('.toggle-submenu').click(function() {
        console.log('sssss');
        $(this).toggleClass('active');
        $(this).next().slideToggle();
        $('.toggle-submenu').not($(this)).removeClass('active');
        $(this).parent().parent().siblings().children().children('.menu-drawer__submenu').not($(this).next()).slideUp();
    });
  }
});


/*23-11-2021- Update to header and navigation - end*/
/**Fix Shopping Cart Layout staert**/
 $(".afterpay-paragraph").appendTo(".cart-afterpay-group");
/**Fix Shopping Cart Layout end**/



/**Tabs Section scroll JS**/
$('a[href*="#"]').click(function() {
    var target = $(this.hash);
      $('html,body').stop().animate({
        scrollTop: target.offset().top - 125
      }, 'linear');   
});
/**Tabs Section scroll JS END**/

/**Add to cart Sticky JS**/
function sticky_relocate() {
  var footerElement = $("#shopify-section-footer_custom");
    if (footerElement.length > 0) {
  var window_top = $(window).scrollTop();
  var footer_top = footerElement.offset().top - 320;
  var div_top = $('#sticky-anchor').offset().top - 170;
  var div_height = $("#sticky").height();
   if (window.matchMedia("(max-width: 767px)").matches) {
     var description_height = $('#product-description .product-description').height();
     var pdpslider = $('.product_media_slider').height()
     var sliderdesc =  description_height + pdpslider;
     var div_top = $('#sticky-anchor').offset().top - sliderdesc;
   }
  if (window_top + div_height > footer_top) {
    $('.stickyform').removeClass('stick');
    $('.stickyform').find('.product-form__controls-group').find('.dropdown').removeClass('active');
  } else if (window_top > div_top) {
    $('.stickyform').addClass('stick');
  } else {
    $('.stickyform').removeClass('stick');
    $('.stickyform').find('.product-form__controls-group').find('.dropdown').removeClass('active');
  }
    }
}
 
  $(function () {
    $(window).scroll(sticky_relocate);
    sticky_relocate();
  });


/**Add to cart Sticky JS END**/

/*PDP redesign*/

/* Header Modification: Header Newsletter Drwaer End */
   /**Announcement Bar Start**/
function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
document.addEventListener("DOMContentLoaded", (event) => {
function checkCookie() {
  let annunce = getCookie("annuncy");
  const announcementbarsrn = document.querySelector(".utility-bar");
   const bar_hide = document.querySelector("main");
  if( !announcementbarsrn ){
    return false;
  }
  const header = document.querySelector("header");
  if ( annunce == true ) {
    announcementbarsrn.classList.add("hide");
     bar_hide.classList.add('hide-bar');
    document.querySelector('body').classList.remove("announce-b-body");
    header.classList.remove("top-announce");
  }else{
     bar_hide.classList.remove('hide-bar');
    announcementbarsrn.classList.remove("hide");
    header.classList.add("top-announce");
  }
}
checkCookie();
const announceclose = document.querySelector(".announce-close");
if( announceclose ){
 announceclose.addEventListener("click", function () {
    setCookie("annuncy", true, 1);
    document.querySelector('.utility-bar').classList.add('hide');
   document.querySelector('main').classList.add('hide-bar');
    document.querySelector("header").classList.remove("top-announce");
    document.querySelector('body').classList.remove("announce-b-body");
  }); 
}
});
/**Announcement Bar End**/
